import React from "react";
import "./BadgePopup.css";

const BadgePopup = ({
  isOpen,
  setIsOpen,
  level,
  badgeImg,
  heading,
  subtitle,
  mainImg,
  description,
  buttonText = "Begin!", // New Dynamic Prop with default value
}) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={() => setIsOpen(false)}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>
        <h3 className="popup-level">{level}</h3>

        <div className="badge-header-container">
          <img src={badgeImg} className="badge-icon" alt="Badge" />
          <div className="text-group">
            <h2 className="popup-heading">{heading}</h2>
            {subtitle && <p className="popup-subtitle">{subtitle}</p>}
          </div>
        </div>

        {/* The Green Container */}
        <div className="popup-img-container">
          <img src={mainImg} alt="Visual" className="popup-main-img" />
        </div>

        <p className="popup-description">{description}</p>

        <button
          className="popup-close-btn"
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(false);
          }}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default BadgePopup;
